import * as Types from '../types-api.generated';

import { MarketNftGridFields, UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiNftsSearchVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
  perPage: Types.Scalars['Limit'];
  page: Types.Scalars['Int'];
  accountAddress?: Types.InputMaybe<Types.Scalars['ID']>;
  collectionAddresses?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
  distinct?: Types.InputMaybe<Types.Scalars['Boolean']>;
  distinctAssetKey?: Types.InputMaybe<Types.Scalars['String']>;
  exhibitionId?: Types.InputMaybe<Types.Scalars['Int']>;
  marketAvailability?: Types.InputMaybe<Types.ApiNftMarketAvailability>;
  ownerAccountAddress?: Types.InputMaybe<Types.Scalars['ID']>;
  sortOrder?: Types.InputMaybe<Types.ApiNftSortOption>;
}>;


export type ApiNftsSearch = { nftsSearchV2Db: { distinctAggregates: object, search: { page: number, items: Array<{ chainId: ChainId, name: string | null, id: string, tokenId: number, contractAddress: Address, saleStartsAt: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, activeAuction: { duration: number, id: number, reservePrice: number, state: Types.ApiAuctionState, expiryDate: string | null, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, activeBuyNow: { amount: number } | null, activeOffer: { amount: number, expiryDate: string } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null }> } } };



export const ApiNftsSearchDocument = /*#__PURE__*/ `
    query NftsSearch($searchTerm: String!, $perPage: Limit!, $page: Int!, $accountAddress: ID, $collectionAddresses: [ID!], $distinct: Boolean, $distinctAssetKey: String, $exhibitionId: Int, $marketAvailability: NftMarketAvailability, $ownerAccountAddress: ID, $sortOrder: NftSortOption) {
  nftsSearchV2Db(
    query: $searchTerm
    perPage: $perPage
    page: $page
    accountAddress: $accountAddress
    collectionAddresses: $collectionAddresses
    distinct: $distinct
    distinctAssetKey: $distinctAssetKey
    exhibitionId: $exhibitionId
    marketAvailability: $marketAvailability
    ownerAccountAddress: $ownerAccountAddress
    sort: $sortOrder
  ) {
    search {
      items {
        ...MarketNftGridFields
      }
      page
    }
    distinctAggregates
  }
}
    ${MarketNftGridFields}
${UserLightFragment}
${MediaFragment}`;

export const useNftsSearch = <
      TData = ApiNftsSearch,
      TError = ClientError
    >(
      variables: ApiNftsSearchVariables,
      options?: Omit<UseQueryOptions<ApiNftsSearch, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiNftsSearch, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiNftsSearch, TError, TData>(
      {
    queryKey: ['NftsSearch', variables],
    queryFn: apiFetcher<ApiNftsSearch, ApiNftsSearchVariables>(ApiNftsSearchDocument, variables),
    ...options
  }
    )};

useNftsSearch.getKey = (variables: ApiNftsSearchVariables) => ['NftsSearch', variables];

export const useInfiniteNftsSearch = <
      TData = InfiniteData<ApiNftsSearch>,
      TError = ClientError
    >(
      variables: ApiNftsSearchVariables,
      options: Omit<UseInfiniteQueryOptions<ApiNftsSearch, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiNftsSearch, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiNftsSearch, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NftsSearch.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiNftsSearch, ApiNftsSearchVariables>(ApiNftsSearchDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNftsSearch.getKey = (variables: ApiNftsSearchVariables) => ['NftsSearch.infinite', variables];


useNftsSearch.fetcher = (variables: ApiNftsSearchVariables, options?: RequestInit['headers']) => apiFetcher<ApiNftsSearch, ApiNftsSearchVariables>(ApiNftsSearchDocument, variables, options);
